<div *ngIf="userData"
     class="hello"
     nz-flex
     [nzJustify]="'flex-start'"
     [nzAlign]="'center'"
>
  <img src="assets/Hello.svg" class="icon-hello" />
  <h2>¡Hola, {{ userData.given_name }}! Bienvenido a tus <span class="title-blue">Actividades Recientes</span></h2>
</div>
<div class="container-dashboard">
  <div class="projects-header">
    <div class="selector-section">
      <p class="selector-title">Selecciona un proyecto para visualizar:</p>
      <app-projects-search class="selector-input" [defaultPlaceHolder]="'Todos los proyectos'"
      (projectSelected)="projectSelected($event)" iconSide="right"></app-projects-search>
    </div>
    <!-- <button nz-button class="btn-create-project">
      <span nz-icon nzType="plus" class="icon-create-project"></span>
      <span class="text-create-project">Crear proyecto</span>
    </button> -->
  </div>
  @if ((+projectId > 0 || projectId === 'all') && userPermissions?.canViewAmounts) {
    <app-project-card [idProject]="projectId" class="project-card-container"></app-project-card>
  }
  <!-- <app-activity-table [projectId]="projectId" class="project-card-container"></app-activity-table> -->
  @if (userPermissions?.requisitions) {
    <div class="tables-container">
      <div class="controls">
        <div class="title-header">
          <h4>Últimas requisiciones</h4>
          <button nz-button (click)="goToMyRequisitions()">Ir a mis requisiciones</button>
        </div>
      </div>
      @if (userPermissions?.canViewAmounts) {
        <div class="charts-container">
          <app-requisition-pie-chart chart="chart1" [pieChartDataSource]="requisitionCakeData" [chartMonthlyDataSource]="requisitionChartMonthlyData1" [chartWeeklyDataSource]="requisitionChartWeeklyData1"></app-requisition-pie-chart>
          <app-requisition-pie-chart chart="chart2" [pieChartDataSource]="requisitionCakeData"></app-requisition-pie-chart>
        </div>
      }
      <app-info-dashboard-card class="info-card-container" [data]="infoRequisitionsCard"></app-info-dashboard-card>
      <app-dashboard-requisition-table
      [requisitionTabsList]="requisitionsTabs"
      [userPermissions]="userPermissions"
      [requisitionTableData]="requisitionTableData"
      [totalRequisitions]="totalRequisitions"
      (highlightRequisition)="onHighlightRequisition($event)"
      ></app-dashboard-requisition-table>
    </div>
  }
  @if (userPermissions?.estimations) {
    <div class="tables-container">
      <div class="controls">
        <div class="title-header">
          <h4>Últimas estimaciones</h4>
          <!-- <button nz-button (click)="goToMyEstimations()" display="none">Ir a mis estimaciones</button> -->
        </div>
      </div>
      <div class="charts-container">
        <app-estimation-pie-chart chart="chart1" [pieChartDataSource]="estimationCakeData"
          [chartMonthlyDataSource]="estimationChartMonthlyData1"
          [chartWeeklyDataSource]="estimationChartWeeklyData1"
        ></app-estimation-pie-chart>
        <app-estimation-pie-chart chart="chart2" [pieChartDataSource]="estimationCakeData"></app-estimation-pie-chart>
      </div>
      <!-- <app-info-dashboard-card class="info-card-container" [data]="infoEstimationsCard"></app-info-dashboard-card>
      <app-dashboard-estimation-table
        [estimationTableData]="estimationTableData"
        [totalEstimations]="totalEstimations"
      ></app-dashboard-estimation-table> -->
    </div>
  }
</div>
